import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Card,  CardBody,  CardTitle, Collapse} from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from "react-redux";


// components
import PromotionFilters from "./_filters";
import TranslateButton from "../../../components/buttons/TranslateButton";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import ConfirmDeleteForm from "../../../components/confirmAlertForms/ConfirmDeleteForm";
import { showToastCustom } from "../../../components/toast/customToast";
import { ButtonTableFilter, GenericTableButton,  } from "../../../components/buttons/buttonsActions";

// labels
import {
    ARE_YOU_SHURE_TITLE, CONFIRM_SYNC, CONFIRM_YES,
    error, LIST, NO, NO_DATA_FOUND,
} from "../../../components/i18n/i18n";
import {
    TT_BENEFIT, TT_DELETE, TT_EDIT,
    TT_PRODUCTS, TT_TABOPTION, TT_UPD_PRICES
} from "../../../components/i18n/toolTips";

// services
import { promotionService } from "../../../jwt/_services/promotions/promotionService";
import { productPriceService } from "../../../jwt/_services/promotions/productPriceService";

// actions
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {remove, search, update} from "../../../redux/actions/promo/promotionActions";


const PromotionList = (props) => {
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const { app } = props.mainProps
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    const [projectName, setProjectName] = useState(props.mainProps?.app?.fbDataBase?.name);

    const [collapsed, setCollapsed] = useState(true);

    // asignar los valores por default del filtro
    useEffect( () => {
        if( !app.id || filter)
            return

        setProjectName(app?.fbDataBase?.name)

        props.setFilter( {
            onlyRegistered : true,
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                status : true
            }
        } )
    }, [ app ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize, filter ]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => <ConfirmDeleteForm
                onClose={onClose}
                data={data}
                deleteItem={ data => props.remove(data?.id) }
            />
        });

    const editItem = (data, editMode, option) => {
        props.setViewMode(option);
        props.setItem(data);
        props.setForm(editMode, false, false);
    }

    const showFilters = () => setCollapsed(!collapsed);

    const confirmSyncSinglePromotionPrices = (data)=> confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => <div className='custom-ui'>
                <h1>{ARE_YOU_SHURE_TITLE}</h1>
                <p>{CONFIRM_SYNC}</p>
                <button onClick={onClose}>{NO}</button>
                <button className={"btn-alert-delete"} onClick={() => {
                    syncSinglePromotionPrices(data)
                    onClose();
                }}>
                    {CONFIRM_YES}
                </button>
            </div>
        });

    const syncSinglePromotionPrices = (data) => {
        const dataRequest = {
            id : data?.id
        }
        setLoading(true);
        productPriceService.syncSinglePromotionPrices(dataRequest)
            .then(_ => {
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row, true, 'FORM')}/>
        <GenericTableButton toolTip={TT_PRODUCTS} icon={'fa-box-open'} permission={'edit'} onClick={() => editItem(row, false, 'PRODUCTS')}/>
        {
            projectName === 'parques' && <>
                <GenericTableButton toolTip={TT_TABOPTION} icon={'fa-columns'} permission={'edit'} onClick={() => editItem(row, false, 'TABOPTS')}/>
                <GenericTableButton toolTip={TT_BENEFIT} icon={'fa-cart-plus'} permission={'edit'} onClick={() => editItem(row, false, 'BENE')}/>
            </>
        }
        <GenericTableButton toolTip={TT_UPD_PRICES} icon={'fa-dollar-sign'} permission={'prices'} onClick={() => confirmSyncSinglePromotionPrices(row)}/>
        <TranslateButton item={row} service={promotionService} />
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>



    const handleStatusChange = (id, data, status) => {
        props.update(id, {
            fbDataBase: { id : fbDataBaseId },
            item: { ...data, status, id  }
        })
    }




    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'uid',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'code',
            text: 'Codigo',
        }, {
            dataField: 'coupon',
            text: 'Cupon',
            headerAlign: 'center',
            align: 'center',
        }, {
            dataField: 'startDate',
            text: 'Desde',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '100px'},
        }, {
            dataField: 'endDate',
            text: 'Hasta',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '100px'},
        }, {
            dataField: 'showOrder',
            text: 'Orden',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
        }, {
            dataField: 'status',
            text: "Activo",
            headerStyle: {width: '50px'},
            headerAlign: 'center',
            formatter: (cell, row) => <GenericSwitch
                id={ row?.id }
                initialState={ row?.status }
                onChange={ handleStatusChange }
            />
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '450px'},
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
            </div>
        </CardTitle>
        <Collapse isOpen={collapsed}  >
            <PromotionFilters />
        </Collapse>
        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
    setLoading,
    update,
})
export default connect(mapStateToProps, mapActionsToProps)(PromotionList)
